import { getAll as getAllFacture } from '@/api/facture/index';
import { getAll as getAllDevis } from '@/api/devis/index';
import { getAll as getAllCommande } from '@/api/commande/index';
import { TYPE_DEVIS, TYPE_COMMANDE, TYPE_FACTURE } from '@/configuration/devisConf';

async function devisGetAllAsync(params) {
  const devisCommande = (await getAllDevis(params)).data.result;
  return devisCommande;
}

async function commandeGetAllAsync(params) {
  const commande = (await getAllCommande(params)).data.result;
  return commande;
}

async function factureGetAllAsync(params) {
  const devisCommande = (await getAllFacture(params)).data.result;
  return devisCommande;
}

export default async function getDcfByType(type, params) {
  let result;
  switch (type) {
    case TYPE_DEVIS:
      result = await devisGetAllAsync(params);
      break;
    case TYPE_COMMANDE:
      result = await commandeGetAllAsync(params);
      break;
    case TYPE_FACTURE:
      result = await factureGetAllAsync(params);
      break;
    default:
      throw new Error('getAll type DCF mauvais');
  }
  return result;
}
